<template>
  <div class="sidebar-nav">
    <router-link class="nav-link home" :to="{ name: 'home' }">
      <img src="../assets/sidebar-logo.png" />
    </router-link>
    <div class="nav-link">
      <img src="../assets/icon-user-inactive.png" />
    </div>
    <router-link class="nav-link" :class="{active: $route.name === 'clusters' || $route.name === 'locations'}" :to="{ name: 'clusters' }">
      <transition name="fade">
        <img v-if="$route.name === 'clusters' || $route.name === 'locations'" src="../assets/icon-marker-active.png" />
        <img v-else src="../assets/icon-marker-inactive.png" />
      </transition>
    </router-link>
    <router-link class="nav-link" :class="{active: $route.name === 'savedViews'}" :to="{ name: 'savedViews' }">
      <transition name="fade">
        <img v-if="$route.name === 'savedViews'" src="../assets/icon-bookmark-active.png" />
        <img v-else src="../assets/icon-bookmark-inactive.png" />
      </transition>
    </router-link>
    <div class="nav-link" :class="{active: $route.name === 'indicators'}">
      <transition name="fade">
        <i class="fa fa-bar-chart"></i>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidebarnav',
  methods: {

  },
  created (){

  },
  mounted (){

  },
  data () {
    return {
      msg: 'Sidebar'
    }
  }
}
</script>

<style lang="scss">
@import '../scss/global';

.sidebar-nav {
	background: $secondary-color;

  .fa-bar-chart {
    padding: 0.75em;
    font-size: 1.5em;
    padding-left: 1em;
  }

	.nav-link {
		position: relative;
		color: #96836e;
		width: $nav-width;
		height: $nav-width;
		display: block;
		transition: all $animation-speed;
		&.home {
			background: $primary-color;
			color: $white;
		}
		&.active {
			background: $white;		
			color: $primary-color;
		}

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }

		.link-icon {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			font-size: 24px;
		}
	}

}
</style>



// WEBPACK FOOTER //
// SidebarNav.vue?5bd371b1